import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LabelledTextField from '../LabelledTextField';
import { dateOptions } from '../../utils/dates';
import CircleButton from '../CircleButton';
import { faEye, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import EditHydrantDeficiencyModal from '../../pages/hydrants/EditHydrantDeficiencyModal';

const HydrantDeficiencyTableRow = ({ hydrantDeficiency, onDelete, onEdit }) => {
    const [startDelete, setStartDelete] = useState(false);
    const [editHydrantDeficiencyModalOpen, setEditHydrantDeficiencyModalOpen] = useState(false);

    const handleEdit = () => {
        setEditHydrantDeficiencyModalOpen(false);
        onEdit();
    };

    return (
        <tr id={hydrantDeficiency.id}>
            <td>{hydrantDeficiency.deficiencyType}</td>
            <td>{hydrantDeficiency.note}</td>
            <td>{hydrantDeficiency.resolved ? 'Yes' : 'No'}</td>
            <td className="action-cell">
                <div className="list-actions">
                    <CircleButton icon={faEdit} type="primary" title="Edit" onClick={() => setEditHydrantDeficiencyModalOpen(true)} />
                    <CircleButton icon={faTrashAlt} type="danger" title="Delete" onClick={() => setStartDelete(true)} />
                </div>
                {startDelete && (
                    <div className="row-confirm">
                        <div className="form-actions">
                            <span>Are you sure you want to delete this record?</span>
                            <button type="button" className="btn btn-primary" onClick={() => onDelete(hydrantDeficiency.id)}>Yes</button>
                            <button type="button" className="btn btn-secondary" onClick={() => setStartDelete(false)}>No</button>
                        </div>
                    </div>
                )}
            </td>
            <EditHydrantDeficiencyModal open={editHydrantDeficiencyModalOpen} hydrantDeficiency={hydrantDeficiency} onCancel={() => setEditHydrantDeficiencyModalOpen(false)} onComplete={handleEdit} />
        </tr>
    );
};

export default HydrantDeficiencyTableRow;